import React from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import { ICarnetsFinancials } from "Dashboard/scenes/Projects/domain/ICarnetsFinancials";
import { FormatNumber, FormatNumberOrNull, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { FormatDateShort } from "utils/dateUtils";
import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasWriteAccessTo } from "utils/authUtil";
import InfoTooltip from "components/Popup/InfoTooltip";
import Popover from "components/Popover/Popover";
import { selectState, setMealPriceSettingsPopover } from "../financials.slice";
import MealPriceSettingsPopover from "./MealPriceSettingsPopover";
import { HIGH_RISE_SALES_MODULE_NAME } from "Dashboard/scenes/HighRiseSales/domain/HighRiseSalesModule";

interface IProps {
  data: ICarnetsFinancials | undefined;
}

const Carnets = ({ data }: IProps) => {
  const dispatch = useAppDispatch();
  const { mealPriceSettingsPopover } = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);

  return (
    <div>
      <h3><strong>KARNETI</strong></h3>
      <section>
        <div className="buildings-box-header">
          {data?.hourlyWorkSummaries.map((hourlyWorkSummary, index) => (
            <div key={index}>
              <span className="right-align">{hourlyWorkSummary.label?.toLowerCase()} suma</span>
              <InfoTooltip
                tooltip={`ukalkulisano ${FormatNumberWithUnitOrNull(hourlyWorkSummary.totalHoursAccrued, 'sati')}; upisano ${FormatNumberWithUnitOrNull(hourlyWorkSummary.totalHoursBooked, 'sati')}`}
                classesProp="strong-txt center-align txt-underline"
                element="span">
                {FormatNumberOrNull(hourlyWorkSummary.totalHoursAccrued)}
              </InfoTooltip>
              <span className="strong-txt center-align txt-underline flexBasis180">
                {FormatNumberWithUnitOrNull(hourlyWorkSummary.totalHoursCost, "rsd")}
              </span>
            </div>
          ))}
          <div>
            <span className="right-align carnets-text-fix flexBasis75">
              bonus
            </span>
            <span className="strong-txt center-align txt-underline wider-text">
              {data?.totalBonusesCost && FormatNumber(data.totalBonusesCost)}{" "}
              rsd
            </span>
            <span></span>
          </div>
          <div>
            <span className="right-align carnets-text-fix flexBasis75">
              obroci
            </span>
            <span className="strong-txt center-align txt-underline wider-text">
              {data?.totalMealsCost && FormatNumber(data.totalMealsCost)} rsd
            </span>
            {hasWriteAccessTo(user, HIGH_RISE_SALES_MODULE_NAME)
              ? <InfoTooltip
                tooltip="Podesi cenu obroka za izabrani projekat"
                classesProp="button-wrapp" element="span">
                <button onClick={(e) => dispatch(setMealPriceSettingsPopover({
                  isOpen: true, left: e.pageX, top: e.pageY
                }))}>
                  <SettingsIcon className="fas" fontSize="small" />
                </button>
              </InfoTooltip>
              : <span></span>
            }
          </div>
        </div>
        <div className="buildings-box-content">
          <div className="list-wrapp">
            {data?.carnets &&
              data.carnets.map((entry, index) => (
                <article key={index}>
                  <div className="col-1">
                    <span className="left strong">{entry.employeeName}</span>
                  </div>
                  <div>
                    <span className="grid-span-2 light-color">
                      {entry.employeeRole}
                    </span>
                    <span className="box-span">{FormatDateShort(entry.date)}</span>
                  </div>
                  {entry.hourlyWork.map(hourlyWorkItem => (
                    <div key={hourlyWorkItem.index}>
                      <span className="box-span right">
                        {FormatNumber(hourlyWorkItem.hours)}
                      </span>
                      <span className="light-color grid-span-2">
                        {hourlyWorkItem.label?.toLowerCase()}
                      </span>
                    </div>
                  ))}
                </article>
              ))}
          </div>
        </div>
      </section>
      <Popover
        isOpen={mealPriceSettingsPopover.isOpen}
        onClose={() => dispatch(setMealPriceSettingsPopover({ isOpen: false }))}
        title="Cena obroka"
        direction="right"
        arrowStyle={{ top: "50%" }}
        position={{
          left: mealPriceSettingsPopover.left,
          top: mealPriceSettingsPopover.top,
          offsetLeft: 20, offsetTop: -117
        }}
      >
        <MealPriceSettingsPopover />
      </Popover>
    </div>
  );
};

export default Carnets;
